module.exports = __webpack_public_path__ + "img/upload_icon.1a9dac67.svg";